define('modules/accounts/users/detail/form-user-view',['require','exports','module','views/BaseView','env','helpers/CommonHelper','ldsh!./form-user-template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var Config = require("env");
  var CommonHelper = require("helpers/CommonHelper");
  var View = BaseView.extend({
    template: require("ldsh!./form-user-template"),

    serialize: function () {
      var templateData = {
        newUser: !this.model.get("id"),
        user: this.model,
        profile: this.options.profile,
        groupId: this.options.groupId,
        allowSecurityOptionsByGroup: this.checkAllowSecurityOptionsByGroup(),
        commonHelper: CommonHelper,
        isSuperAdmim: this.options.isSuperAdmim,
      };

      return templateData;
    },

    checkAllowSecurityOptionsByGroup: function () {
      return (
        Config.securityOptionsAllowGroups.length === 0 ||
        $.inArray(
          parseInt(this.options.groupId),
          Config.securityOptionsAllowGroups
        ) !== -1
      );
    },
  });

  module.exports = View;
});

